export default "__VITE_ASSET__bqpnXdkT__"